import { useTheme } from "@emotion/react";
import { MdOutlineContactPage } from "react-icons/md";
import { Link } from "react-router-dom-v5-compat";
import { getMegaraxPath } from "@megaron/megarax-uri";

type Props = {
  regions?: string[];
  customerCount?: number;
};

export const CustomersButton = ({ regions, customerCount }: Props) => {
  const theme = useTheme();

  const customersUrl = getMegaraxPath.uri("megarax://crm/customers/new-list", {
    filters: {
      regions: regions,
      page: 0,
      searchText: "",
      isPro: false,
      isAffiliate: false,
      isMyRegion: false,
      status: ["unverified", "verified", "vip"],
    },
  });

  return (
    <Link
      to={customersUrl}
      css={{
        display: "flex",
        margin: "20px 0",
        height: "46px",
        alignItems: "center",
        borderRadius: theme.smallBorderRadius,
        overflow: "hidden",
        backgroundColor: "white",
        cursor: "pointer",
      }}
    >
      <div
        css={{
          display: "flex",
          gap: "6px",
          background: theme.colors.primary,
          color: "white",
          alignItems: "center",
          height: "100%",
          padding: "6px 12px",
        }}
      >
        <MdOutlineContactPage />
        Klienci
      </div>
      <span css={{ color: theme.colors.primary, paddingLeft: "15px" }}>{customerCount}</span>
    </Link>
  );
};
